import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

const KEY = "cookie_consent";

export default function CookieConsent() {
  const { user } = useAuth();
  const [visible, setVisible] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    if (pathname === "/privacy") return;
    try {
      if (!localStorage.getItem(KEY)) setVisible(true);
    } catch {
      /* localStorage blocked — don't nag */
    }
  }, [pathname]);

  const dismiss = (choice) => {
    try { localStorage.setItem(KEY, choice); } catch { /* ignore */ }
    setVisible(false);
  };

  if (!visible || pathname === "/privacy") return null;

  return (
    /* Mobile floating-element sweep (2026-02): signed-in <lg lifts the banner
       above the bottom tab bar so Explore/Discover stay tappable while consent
       is pending; desktop (lg+) keeps the bottom corner. */
    <div
      data-testid="cookie-banner"
      role="dialog"
      aria-label="Cookie consent"
      className={`fixed left-4 right-4 sm:left-6 sm:right-6 md:left-auto md:right-6 md:max-w-md z-[9998] rounded-2xl border border-neutral-200 bg-white/95 backdrop-blur shadow-lg p-4 sm:p-5 ${
        user
          ? "bottom-[calc(4rem+env(safe-area-inset-bottom)+0.75rem)] lg:bottom-4"
          : "bottom-[calc(env(safe-area-inset-bottom)+1rem)]"
      }`}
    >
      <div className="text-sm text-neutral-700 leading-relaxed">
        We use cookies to keep you signed in and to understand how CivicHearth is used.
        See our{" "}
        <Link
          data-testid="cookie-privacy-link"
          to="/privacy"
          className="text-forest font-medium underline underline-offset-2 hover:text-forest-hover"
        >
          Privacy policy
        </Link>
        . By continuing, you consent to essential cookies.
      </div>
      <div className="mt-3 flex flex-wrap gap-2 justify-end">
        <button
          data-testid="cookie-essential-only"
          onClick={() => dismiss("essential")}
          className="text-xs px-4 py-2 rounded-full border border-neutral-300 text-neutral-700 hover:border-forest hover:text-forest transition-colors"
        >
          Essential only
        </button>
        <button
          data-testid="cookie-accept-all"
          onClick={() => dismiss("accepted")}
          className="text-xs px-4 py-2 rounded-full bg-forest text-white hover:bg-forest-hover transition-colors"
        >
          Accept all
        </button>
      </div>
    </div>
  );
}
